export default "__VITE_ASSET__Dv2WED07__"